import { render, staticRenderFns } from "./SampleUpload.vue?vue&type=template&id=79f62254&"
import script from "./SampleUpload.vue?vue&type=script&lang=ts&"
export * from "./SampleUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports